<form (ngSubmit)="submit()" #form="ngForm">
  <nb-card nbSpinnerStatus="primary">
    <nb-card-header>
      <span class="title">
        @if (fromYear && toYear) {
          {{ 'Delay from {from} to {to}' | translate:{ from: fromYear, to: toYear } }}
        } @else {
          {{ scenario?.name }}
        }
      </span>
    </nb-card-header>
    <nb-card-body>
      <p>
        <br/>
        <!-- UPDATING YEAR -->
        @if (fromYear && toYear) {
          <span
          [innerHTML]="'Confirm the delay for the {nbInvest} selected investments ?' | translate:{
            nbInvest: investmentsIds?.length,
          }"
          ></span>
          <div class="motive row">
            <div class="mtv-label col-2">
              {{ 'Motive' | translate}} :
            </div>
            <div class="col-10">
              <nb-select [(selected)]="reasonId">
                @for (reason of reasons; track reason) {
                  <nb-option [value]="reason.id">
                    {{ reason.name }}
                  </nb-option>
                }
              </nb-select>
            </div>
          </div>
        }
        <!-- UPDATING STATUS -->
        @if (fromStatus && toStatus) {
          <span
          [innerHTML]="'You are about to change the status of {nbInvest} investment(s) from <b>{from}</b> to <b>{to}</b>' | translate:{
            nbInvest: investmentsIds?.length, from: fromStatus, to: toStatus
          }"
          ></span>
        }
        <!-- ADD TAG -->
        @if (tag && addingTag) {
          <span
          [innerHTML]="'You are about to add the tag {tag} to {nbInvest} investment(s)' | translate:{
            nbInvest: investmentsIds?.length, tag: tag
          }"
          ></span>
        }
        <!-- REMOVE TAG -->
        @if (tag && removingTag) {
          <span
          [innerHTML]="'You are about to remove the tag {tag} from {nbInvest} investment(s)' | translate:{
            nbInvest: investmentsIds?.length, tag: tag
          }"
          ></span>
        }

        @if(closingPrecision && fromStatus && toStatus) {
          <br>
          <span>
            {{ closingPrecision }}
          </span>
        }
        <br/><br/>
        
        @if (linkedInvestmentsData?.length) {
          <p>{{ "Warning, the following investments are linked to one or multiple other investments" | translate }}.</p>
          <ul>
          @for (data of linkedInvestmentsData; track data) {
            <li>
              {{ data.perimeter }} : {{ data.investment_label }} {{ 'in' | translate }} {{ getLinkedInvestmentYear(data) }} {{ 'for' | translate }} {{ data.budget | ngxCurrency:currency }}
            </li>
          }
          </ul>
        } @else {
          {{ 'Processing may take several seconds' | translate }}
        }
      </p>
    </nb-card-body>
    <nb-card-footer class="text-right">
      <button nbButton type="button" (click)="close()" status="danger" class="cancel">
        {{ 'theme.status-change-dialog.discard' | translate }}
      </button>
      <button nbButton type="submit">
        {{ 'theme.status-change-dialog.ok' | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
